import React, { useEffect } from 'react';
import { fetchPostQuery } from '/src/api';
import { getCookie, setCookie } from '/src/utils';
import {
    useStoreConfigContext,
    ModalsContextProvider,
    AuthContextProvider,
    CartContextProvider,
    useBlocksContext,
    WishListsContextProvider,
    MessagesContextProvider,
} from '/src/providers';
import { Loader, Page404 } from '/src/components';
import {
    trustpilotLoadWidget,
    intercomLoad,
    facebookLoadPixel,
    googleLoadRatingBadge,
    googleLoadTagManager,
    pushNotification,
    justunoLoad,
} from '/src/services';
import { COOKIE_CONSENT } from '/src/consts';
import App from './app';

const Config = () => {
    const {
        storeConfig,
        isLoadingStoreConfig,
        storeConfigErrors,
        getStoreConfig,
    } = useStoreConfigContext();
    const { isLoadingBlocks, getBlocks } = useBlocksContext();

    useEffect(() => {
        if (storeConfig) {
            const {
                locale,
                intercom_app_id,
                merchant_id,
                googletagmanager_container_id,
                affiliate_enabled,
                affiliate_referral_param,
                affiliate_cookie_lifetime_days,
            } = storeConfig;
            const queryParams = new URLSearchParams(window.location.search);
            const acc = queryParams.get(affiliate_referral_param);
            const referrer = document.referrer;

            if (affiliate_enabled && acc && acc !== getCookie('affiliate_identifier')) {
                setCookie('affiliate_identifier', acc, affiliate_cookie_lifetime_days);

                if (referrer && (new URL(referrer)).hostname !== window.location.hostname) {
                    setCookie('affiliate_referrer', referrer, affiliate_cookie_lifetime_days);
                }

                fetchPostQuery({ query: `mutation { affiliateClickEvent }` })
                    .catch(() => {});
            }

            document.documentElement.setAttribute('lang', locale.replace('_', '-'));
            intercomLoad(intercom_app_id);
            facebookLoadPixel();
            justunoLoad();

            const isDevice = /Mobile|Android|iPhone|iPad/i.test(navigator.userAgent);

            if (!isDevice) {
                googleLoadRatingBadge(merchant_id);
            }

            if (getCookie(COOKIE_CONSENT)) {
                googleLoadTagManager(googletagmanager_container_id || 'GTM-TX3RJRV');
            }
        }
    }, [storeConfig]);

    useEffect(() => {
        getStoreConfig();
        getBlocks();
        trustpilotLoadWidget();
        pushNotification();
    }, []);

    if (storeConfigErrors) {
        return <Page404 />;
    }

    if (!storeConfig || isLoadingStoreConfig || isLoadingBlocks) {
        return <Loader />;
    }

    return (
        <AuthContextProvider>
            <WishListsContextProvider>
                <CartContextProvider>
                    <MessagesContextProvider>
                        <ModalsContextProvider>
                            <App />
                        </ModalsContextProvider>
                    </MessagesContextProvider>
                </CartContextProvider>
            </WishListsContextProvider>
        </AuthContextProvider>
    );
};

export default Config;
